export default __webpack_public_path__ + "static/media/Logo.e1e04c0d.png";